import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { step1Schema } from "./schemas";

export type Step1FormData = yup.InferType<typeof step1Schema>;

type BusinessEntityFormDefaultValues = yup.InferType<typeof step1Schema>;

export const useStep1Form = ({
  defaultValues,
}: {
  defaultValues: BusinessEntityFormDefaultValues;
}) => {
  const form = useForm<Step1FormData>({
    defaultValues: defaultValues,
    resolver: yupResolver(step1Schema),
  });

  return form;
};
